<template>
  <div class="logos">
    <div v-for="logo in logos" :key="logo">
      <FootLogoComponent :logo="logo" />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import FootLogoComponent from "./FooterLogo.vue";

export default defineComponent({
  name: "LogosComponent",
  components: { FootLogoComponent },

  props: {
    logos: {
      required: true,
      type: Object as PropType<string[]>,
    },
  },
});
</script>

<style scoped>
.logos {
  width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around !important;
  overflow: hidden;
  padding-top: 10px;
}
</style>
